import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a3d47f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,CardLesson: require('/home/smiley/3df/components/Card/CardLesson/CardLesson.vue').default,BlockImage: require('/home/smiley/3df/components/Block/BlockImage/BlockImage.vue').default,CardArticle: require('/home/smiley/3df/components/Card/CardArticle/CardArticle.vue').default,Banner: require('/home/smiley/3df/components/Banner/Banner.vue').default,SectionRegister: require('/home/smiley/3df/components/Section/SectionRegister/SectionRegister.vue').default})
